import {Component, Input, OnInit} from '@angular/core';
import {cIOMAPPEDCOUNTER} from "../counterStatus";
import {CounterlistComponent} from "../counterlist/counterlist.component";

@Component({
  selector: 'app-counterdetails',
  templateUrl: './counterdetails.component.html',
  styleUrls: ['./counterdetails.component.css']
})
export class CounterdetailsComponent implements OnInit {
  @Input()
  refNumber: number = -1;
  cntStatus: cIOMAPPEDCOUNTER;
  used: string = "";


  constructor(private counterlistComponent: CounterlistComponent) {

    this.cntStatus = new cIOMAPPEDCOUNTER();
    counterlistComponent.Add(this);
  }

  UpdateCntState(cntState: cIOMAPPEDCOUNTER): void
  {
    this.cntStatus = cntState;
    this.used = (this.cntStatus.inuse) ? "used" : "free";
  }


  ngOnInit(): void {
  }


}
